export const text = {
  category: "Product Category",
};
